import React from 'react';
import { Grid, TextField, Typography, Autocomplete, Divider } from '@mui/material';
import { investigationFields, investigationOptions } from '../constants/options';

const InvestigationsSection = ({ formData, setFormData, handleChange }) => {
  return (
    <>
      <Typography variant="h6" sx={{ marginTop: 3 }}>
        Investigation
      </Typography>
      <Grid container spacing={2}>
        {investigationFields.key1.map((key, index) => (
          <Grid item xs={12} sm={6} md={4} key={key}>
            <Autocomplete
              freeSolo
              options={investigationOptions[key] || []}
              value={formData[key] || ''}
              onInputChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  [key]: newValue || '',
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={investigationFields.name[index]}
                  variant="outlined"
                  fullWidth
                  name={key}
                />
              )}
            />
          </Grid>
        ))}
        <Grid item xs={12}>
          <TextField 
            fullWidth 
            label="Others(if any)" 
            variant="outlined" 
            onChange={handleChange("other_investigations")} 
            value={formData.other_investigations || ''} 
          />
        </Grid>
      </Grid>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default InvestigationsSection;
